import type { AutocompleteFieldId, MarketingData, MultiTrip, PlaceInfo } from './types';

// --- GLOBAL STATE ---

export const autocompleteState: Record<AutocompleteFieldId, boolean> = {
  pickup: false,
  destination: false,
};

export const fieldState: Record<string, { touched: boolean }> = {
  pickup: { touched: false },
  destination: { touched: false },
  email: { touched: false },
  pickupDate: { touched: false },
  pickupTime: { touched: false },
  returnDate: { touched: false },
  returnTime: { touched: false },
};

export function ensureFieldState(id: string): void {
  if (!fieldState[id]) fieldState[id] = { touched: false };
}

export function touchAllFields(): void {
  for (const key of Object.keys(fieldState)) fieldState[key].touched = true;
}

export const placeData: Record<AutocompleteFieldId, PlaceInfo | null> = {
  pickup: null,
  destination: null,
};

export const marketingData: MarketingData = {
  source: 'direct',
  medium: '',
  campaign: '',
  content: '',
  term: '',
  gclid: '',
  dclid: '',
  // Rozszerzone dane z Google Ads ValueTrack parameters:
  adgroup: '',
  campaign_id: '',
  adgroup_id: '',
  keyword_id: '',
  match_type: '',
  network: '',
  device_from_ad: '',
  im_ref: '',
  referrer: document.referrer || '',
  initialURL: window.location.href,
  first_touch_source: '',
  first_touch_medium: '',
  first_touch_campaign: '',
  first_touch_content: '',
  first_touch_term: '',
  first_touch_gclid: '',
};

// --- MULTI-TRIP STATE & SESSION STORAGE ---

const TRIPS_STORAGE_KEY = 'multiTripsData';
const COUNTER_STORAGE_KEY = 'multiTripCounter';

function loadTripsFromSession(): MultiTrip[] {
  try {
    const raw = sessionStorage.getItem(TRIPS_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as MultiTrip[]) : [];
  } catch {
    return [];
  }
}

export const multiState = {
  trips: loadTripsFromSession(),
  counter: parseInt(sessionStorage.getItem(COUNTER_STORAGE_KEY) ?? '', 10) || 0,
};

export function saveMultiToSession(): void {
  sessionStorage.setItem(TRIPS_STORAGE_KEY, JSON.stringify(multiState.trips));
  sessionStorage.setItem(COUNTER_STORAGE_KEY, multiState.counter.toString());
}

export function resetMultiTrips(): void {
  multiState.trips = [];
  multiState.counter = 0;
  sessionStorage.removeItem(TRIPS_STORAGE_KEY);
  sessionStorage.removeItem(COUNTER_STORAGE_KEY);
}
